<!-- 首页 -->
<template>
  <div>
    <TopBar :new-id="0"></TopBar>
    <div class="intermediate">
      <!-- 轮播图 -->
      <a-carousel style="z-index: 0" :autoplay="true">
        <div class="bgImg carouselImg img1">
          <div class="carouseCard carouseCard-left">
            <div class="carouseCard-title">集抄平台解决方案</div>
            <div class="carouseCard-desc">
              物联网直读水表采用脉冲采样与直读采样技术相结合的独特采样方式，确保机械读数与电子读数一致，通过网络方式进行自动联网通讯，实现水表使用水量的远程自动抄收
            </div>
          </div>
        </div>
        <div class="bgImg carouselImg img2">
          <div class="left">
            <div class="carouseCard carouseCard-right">
              <div class="carouseCard-title">智慧水务解决方案</div>
              <div class="carouseCard-desc">
                实现水务业务系统的控制智能化、数据资源化、管理精确化、决策智慧化，保障水务设施安全运行，使水务业务运营更高效、管理更科学和服务更优质。
              </div>
            </div>
          </div>
        </div>
      </a-carousel>
      <!-- 解决方案 -->
      <div class="schemeCard">
        <div class="schemeCard-margin">
          <div class="schemeCard-title">解决方案</div>
          <div class="schemeCard-line"></div>
          <a-flex class="schemeCard-bottom">
            <SchemeCard :num="0" size="big"></SchemeCard>
            <SchemeCard
              :num="1"
              size="small"
              class="schemeCard-left"
            ></SchemeCard>
          </a-flex>
          <a-flex>
            <SchemeCard :num="2" size="small"></SchemeCard>
            <SchemeCard
              :num="3"
              size="small"
              class="schemeCard-left"
            ></SchemeCard>
            <SchemeCard
              :num="4"
              size="small"
              class="schemeCard-left"
            ></SchemeCard>
          </a-flex>
        </div>
      </div>
      <!-- 关于我们 -->
      <div class="schemeCard">
        <div class="bgImg schemeCard-bgImg schemeCard-margin">
          <div class="schemeCard-title">关于我们</div>
          <div class="schemeCard-line"></div>
          <a-flex align="flex-start">
            <div class="aboutus">
              <div class="aboutus-title">山东沃智达技术有限公司</div>
              <a-flex>
                <div class="aboutus-line1"></div>
                <div class="aboutus-line2"></div>
              </a-flex>
              <div class="aboutus-desc">
                山东沃智达技术有限公司专注于智慧水务领域的创新型科技企业，致力于为水务行业提供先进、高效、可持续的智能化解决方案。业务范围涵盖供水、排水、节水等水务领域的技术咨询、系统设计、软件开发、运维服务等。
              </div>
              <div class="aboutus-desc aboutus-top">
                沃智达始终秉承 “以创新立足市场，以智慧经营未来”
                的经营理念，不断提升自主研发与生产工艺的核心技术能力，贴近客户需求，助力中国智造，持续为用户提供多功能一体化的智慧水务综合管理平台，致力于成为国际领先、以服务为本，覆盖上下游业务领域的综合服务商。
              </div>
            </div>
            <img class="aboutus-img" src="../assets/home3.png" />
          </a-flex>
        </div>
      </div>
      <!-- 新闻动态 -->
      <div class="schemeCard">
        <div class="schemeCard-margin">
          <div class="schemeCard-title">新闻动态</div>
          <div class="schemeCard-line"></div>
          <a-flex>
            <div>
              <img
                v-if="newsCardNum == 0"
                src="../assets/home3 (2).png"
                class="newsCard-img"
              />
              <img
                v-else-if="newsCardNum == 1"
                src="../assets/imageaboutus.png"
                class="newsCard-img"
              />
              <img
                v-else-if="newsCardNum == 2"
                src="../assets/home3.png"
                class="newsCard-img"
              />
              <img
                v-else
                src="../assets/schemeimg (3).png"
                class="newsCard-img"
              />
              <div class="newsCard-title">
                {{ newsCardTiTle }}
              </div>
              <div class="newsCard-desc">
                {{ doText }}
              </div>
            </div>
            <a-carousel :autoplay="true" class="newsCard-left newsCard-card">
              <div>
                <NewsCard
                  size="m"
                  v-for="(item, index) in newsCards"
                  :key="item.id"
                  :content="item"
                  @mousemove="
                    newsCardNum = index;
                    newsCardTiTle = item.title;
                    newsCardDesc = item.body;
                  "
                ></NewsCard>
              </div>
              <div>
                <NewsCard
                  size="m"
                  v-for="(item, index) in newsCards1"
                  :key="item.id"
                  :content="item"
                  @mousemove="
                    newsCardNum = index;
                    newsCardTiTle = item.title;
                    newsCardDesc = item.body;
                  "
                ></NewsCard>
              </div>
              <div>
                <NewsCard
                  size="m"
                  v-for="(item, index) in newsCards2"
                  :key="item.id"
                  :content="item"
                  @mousemove="
                    newsCardNum = index;
                    newsCardTiTle = item.title;
                    newsCardDesc = item.body;
                  "
                ></NewsCard>
              </div>
            </a-carousel>
          </a-flex>
        </div>
      </div>
    </div>
    <BottomBar></BottomBar>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import SchemeCard from "@/components/SchemeCard.vue";
import NewsCard from "@/components/NewsCard.vue";
import { getList } from "@/common/api";

export default defineComponent({
  name: "HomeView",
  components: { SchemeCard, NewsCard },
  setup(props, ctx) {
    const newsCards = ref([] as any);
    const newsCards1 = ref([] as any);
    const newsCards2 = ref([] as any);
    const newsCardNum = ref(0);
    const newsCardTiTle = ref("");
    const newsCardDesc = ref("");
    getList({
      siteId: 1,
      channelId: 9,
      checked: true,
      page: 1,
      perPage: 30,
    }).then((res: any) => {
      // console.log(res);
      if (res.contents) {
        newsCards.value = res.contents.slice(0, 4);
        newsCards1.value = res.contents.slice(4, 8);
        newsCards2.value = res.contents.slice(8, 12);
        newsCardTiTle.value = newsCards.value[0].title;
        newsCardDesc.value = newsCards.value[1].body;
      }
    });
    const doText = computed(() => {
      return newsCardDesc.value.replace(/<\/?[^>]+(>|$)/g, "");
    });
    return {
      newsCards,
      newsCards1,
      newsCards2,
      newsCardNum,
      newsCardTiTle,
      newsCardDesc,
      doText,
    };
  },
});
</script>
<style>
.slick-dots li button {
  background: #2961de !important;
}
.newsCard-card .slick-dots li button {
  width: 10px !important ;
  height: 10px !important;
  background: #356fd0 !important;
  border-radius: 100% !important;
  margin-top: 70px;
  margin-left: 300px;
}
.newsCard-card .slick-dots li {
  width: 23px !important ;
}
.newsCard-card .slick-dots li.slick-active {
  width: 23px !important ;
}
</style>
<style scoped lang="scss">
.aboutus-img {
  transition: all 0.5s; //控制速度，也可不加
}
.aboutus-img:hover {
  transform: scale(1.1); //设置缩放比例
  -ms-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -o-transform: scale(1.1);
  -moz-transform: scale(1.1);
}
.carouselImg {
  width: 100%;
  height: 874px;
}
.img1 {
  background-image: url(../assets/home1.jpg);
}
.img2 {
  background-image: url(../assets/home2.jpg);
}
.left {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.carouseCard {
  display: flex;
  width: 514px;
  display: flex;
  flex-direction: column;
  &-left {
    margin-left: 263px;
    margin-top: 320px;
    text-align: left;
  }
  &-right {
    width: 496px;
    margin-top: 280px;
    margin-right: 271px;
    text-align: left;
  }
  &-title {
    font-weight: bold;
    font-size: 40px;
    color: #000000;
  }
  &-desc {
    font-weight: 400;
    font-size: 16px;
    color: #555555;
    line-height: 36px;
    margin-top: 40px;
  }
}
.schemeCard {
  // width: 1920px;
  background-color: #fff;
  &-margin {
    padding: 69px 276px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &-title {
    font-weight: 400;
    font-size: 32px;
    color: #000000;
    line-height: 38px;
  }
  &-line {
    width: 42px;
    height: 2px;
    background: #0d68a9;
    margin-top: 5px;
    margin-bottom: 64px;
  }
  &-bottom {
    margin-bottom: 20px;
  }
  &-left {
    margin-left: 20px;
  }
  &-bgImg {
    background-image: url(../assets/backgroundaboutus.png);
    width: 100%;
    height: 698px;
  }
}
.aboutus {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &-title {
    font-weight: 400;
    font-size: 26px;
    color: #000000;
    line-height: 30px;
    margin-bottom: 28px;
  }
  &-line1 {
    width: 60px;
    height: 1px;
    background: #356fd0;
    margin-right: 4px;
  }
  &-line2 {
    width: 590px;
    height: 1px;
    background: #d9d9d9;
  }
  &-desc {
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 46px;
    text-align: left;
    width: 656px;
    margin-top: 56px;
  }
  &-top {
    margin-top: 56px;
  }
  &-img {
    width: 690px;
    height: 450px;
    margin-left: 54px;
  }
}
.newsCard {
  &-img {
    width: 644px;
    height: 358px;
  }
  &-title {
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    text-align: left;
    margin-top: 32px;
    margin-bottom: 38px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  &-desc {
    width: 644px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 28px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  &-left {
    margin-left: 46px;
  }
  &-card {
    width: 694px;
    height: 600px;
  }
  &-dots {
    background-color: #356fd0;
  }
}
</style>
